module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-219.333fc7fa.svg";